module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = VIdT
// module chunks = 2